import { MovieStreamMetaFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { Audio } from '@/scenarios/legacy-player/types/config';

export const transfromAudio: (
    audio: MovieStreamMetaFragment['audioMetas'] | undefined
) => Audio[] = (audio) =>
    audio
        ? audio.map((meta) => ({
              label: meta?.title ?? '',
              language: meta?.language ?? '',
          }))
        : [];
